import TwoButtonModal from './TwoButtonModal'

export default TwoButtonModal
